const KEY_CODES = {
    3: 'BREAK',
    8: 'BACKSPACE__DELETE',
    9: 'TAB',
    12: 'CLEAR',
    13: 'ENTER',
    16: 'SHIFT',
    17: 'CTRL',
    18: 'ALT',
    19: 'PAUSE__BREAK',
    20: 'CAPS_LOCK',
    27: 'ESCAPE',
    32: 'SPACEBAR',
    33: 'PAGE_UP',
    34: 'PAGE_DOWN',
    35: 'END',
    36: 'HOME',
    37: 'LEFT_ARROW',
    38: 'UP_ARROW',
    39: 'RIGHT_ARROW',
    40: 'DOWN_ARROW',
    41: 'SELECT',
    42: 'PRINT',
    43: 'EXECUTE',
    44: 'PRINT_SCREEN',
    45: 'INSERT',
    46: 'DELETE',
    48: 0,
    49: 1,
    50: 2,
    51: 3,
    52: 4,
    53: 5,
    54: 6,
    55: 7,
    56: 8,
    57: 9,
    58: ':',
    59: 'SEMICOLON_FIREFOX_EQUALS',
    60: '<',
    61: 'EQUALS_FIREFOX',
    63: 'SS',
    64: '@_FIREFOX',
    65: 'A',
    66: 'B',
    67: 'C',
    68: 'D',
    69: 'E',
    70: 'F',
    71: 'G',
    72: 'H',
    73: 'I',
    74: 'J',
    75: 'K',
    76: 'L',
    77: 'M',
    78: 'N',
    79: 'O',
    80: 'P',
    81: 'Q',
    82: 'R',
    83: 'S',
    84: 'T',
    85: 'U',
    86: 'V',
    87: 'W',
    88: 'X',
    89: 'Y',
    90: 'Z',
    91: 'WINDOWS_KEY__LEFT__CHROMEBOOK_SEARCH_KEY',
    92: 'RIGHT_WINDOW_KEY',
    93: 'WINDOWS_MENU__RIGHT_',
    96: 'NUMPAD_0',
    97: 'NUMPAD_1',
    98: 'NUMPAD_2',
    99: 'NUMPAD_3',
    100: 'NUMPAD_4',
    101: 'NUMPAD_5',
    102: 'NUMPAD_6',
    103: 'NUMPAD_7',
    104: 'NUMPAD_8',
    105: 'NUMPAD_9',
    106: 'MULTIPLY',
    107: 'ADD',
    108: 'NUMPAD_PERIOD_FIREFOX',
    109: 'SUBTRACT',
    110: 'DECIMAL_POINT',
    111: 'DIVIDE',
    112: 'F1',
    113: 'F2',
    114: 'F3',
    115: 'F4',
    116: 'F5',
    117: 'F6',
    118: 'F7',
    119: 'F8',
    120: 'F9',
    121: 'F10',
    122: 'F11',
    123: 'F12',
    124: 'F13',
    125: 'F14',
    126: 'F15',
    127: 'F16',
    128: 'F17',
    129: 'F18',
    130: 'F19',
    131: 'F20',
    132: 'F21',
    133: 'F22',
    134: 'F23',
    135: 'F24',
    144: 'NUM_LOCK',
    145: 'SCROLL_LOCK',
    160: '^',
    161: '!',
    163: '#',
    164: '$',
    165: 'Ù',
    166: 'PAGE_BACKWARD',
    167: 'PAGE_FORWARD',
    169: 'CLOSING_PAREN_AZERTY',
    170: '*',
    171: '~_+_*_KEY',
    173: 'MINUS_FIREFOX_MUTE_UNMUTE',
    174: 'DECREASE_VOLUME_LEVEL',
    175: 'INCREASE_VOLUME_LEVEL',
    176: 'NEXT',
    177: 'PREVIOUS',
    178: 'STOP',
    179: 'PLAY__PAUSE',
    180: 'E-MAIL',
    181: 'MUTE__UNMUTE_FIREFOX',
    182: 'DECREASE_VOLUME_LEVEL_FIREFOX',
    183: 'INCREASE_VOLUME_LEVEL_FIREFOX',
    186: 'SEMI-COLON__Ñ',
    187: 'EQUAL_SIGN',
    188: 'COMMA',
    189: 'DASH',
    190: 'PERIOD',
    191: 'FORWARD_SLASH__Ç',
    192: 'GRAVE_ACCENT__Ñ',
    193: '?,__OR_°',
    194: 'NUMPAD_PERIOD_CHROME',
    219: 'OPEN_BRACKET',
    220: 'BACK_SLASH',
    221: 'CLOSE_BRACKET',
    222: 'SINGLE_QUOTE',
    223: '`',
    224: 'LEFT_OR_RIGHT_?_KEY_FIREFOX',
    225: 'ALTGR',
    226: '<_GIT_>',
    230: 'GNOME_COMPOSE_KEY',
    233: 'XF86FORWARD',
    234: 'XF86BACK',
    255: 'TOGGLE_TOUCHPAD',
};

const KEY_NAMES = {};

// create a key names object for the reverse lookup
Object.entries(KEY_CODES).forEach(([code, name]) => (KEY_NAMES[name] = parseInt(code)));

/**
 * @name keyCodes
 * @constant
 * @memberof app.common
 * @description
 *
 * The list of keycodes.
 */
/**
 * @name keyNames
 * @constant
 * @memberof app.common
 * @description
 *
 * The list of keynames.
 */
angular.module('app.core').constant('keyCodes', KEY_CODES).constant('keyNames', KEY_NAMES);
